module.exports = __webpack_public_path__ + "04_face.bc2d2360.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer1/04_face.png
// module id = oR18
// module chunks = 0